import { Trans, useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { getCurrency } from 'src/services/util';

export default function PaymentReceipt({
  product,
  promotion,
}: {
  product: CheckoutProductData;
  promotion?: CheckoutPromotionCodeData;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="border-t border-ice-blue">
      <div className="container">
        <div className="mt-8 flex justify-between items-center">
          <div className="N_14_R text-brown-grey">{t('payment/service_period_title')}</div>
          <div className="N_14_R text-greyish-brown">
            {product.durationType && (
              <Trans i18nKey={`payment/service_period_${product.durationType.toLowerCase()}`} values={{ period: product.duration }}></Trans>
            )}
          </div>
        </div>
        <div className="mt-2 flex justify-between items-center">
          <div className="N_14_R text-brown-grey">{t('payment/cover_price_title')}</div>
          <div className="N_14_R text-greyish-brown">
            <NumberFormat value={product.amount} displayType={'text'} thousandSeparator={true} prefix={getCurrency(product.region)} />
          </div>
        </div>
        {promotion && promotion.id && (
          <div className="mt-2 flex justify-between items-center">
            <div className="N_14_R text-brown-grey">{t('payment/promotion_title')}</div>
            <div className="N_14_R text-greyish-brown">
              -{' '}
              <NumberFormat
                value={promotion.saleAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={getCurrency(product.region)}
              />
            </div>
          </div>
        )}
        <div className="border-t mt-6 border-ice-blue"></div>
        <div className="mt-7 mb-11 flex justify-between items-center">
          <div className="N_14_R">
            <span>{t('payment/purchase_amount')}</span>
            <span className="text-brown-grey ml-1">({t('payment/purchase_vat')})</span>
          </div>
          <div className="N_22_M">
            <NumberFormat
              value={promotion && promotion.saleAmount ? product.amount - promotion.saleAmount : product.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getCurrency(product.region)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
